var map = {
	"./0tgimg.jpg": "NoIT",
	"./100tgimg.jpg": "cIBO",
	"./101tgimg.jpg": "fMOi",
	"./1tgimg.jpg": "kCcz",
	"./2tgimg.jpg": "9Qj1",
	"./3tgimg.jpg": "56pH",
	"./4tgimg.jpg": "m3X6",
	"./6tgimg.jpg": "MHN8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1VPh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*tgimg\.jpg$
// module id = 1VPh
// module chunks = 2